/**
 * Fetch action types from the API and populate the shared sync store.
 * Called once on app init inside the auth context.
 */
import { setActionTypeEntries } from '@shared/view-system/registries/action-types';
import { logger } from '../lib/logger';
import { fetchJson, type ApiFetch } from '../lib/apiFetchJson';
import { ActionTypeEntryListResponseSchema } from '@shared/schemas/admin-actions';

let initialized = false;
let lastAttempt = 0;

export async function initActionTypes(apiFetch: ApiFetch): Promise<void> {
  if (initialized || Date.now() - lastAttempt < 30_000) return;
  lastAttempt = Date.now();

  try {
    // The backend emits the display shape (getActionTypes in action-type-cache), so no
    // field-level mapping is needed. A non-2xx or malformed body throws into the catch below.
    const entries = await fetchJson(apiFetch, ActionTypeEntryListResponseSchema, '/api/v4/action-types');
    setActionTypeEntries(entries);
    initialized = true;
  } catch (err) {
    // Non-fatal — frontend falls back to slug display. Logged so a drifted wire shape
    // (which empties every action label) is visible rather than silent.
    logger.warn({ err }, '[initActionTypes] failed to load action types');
  }
}

export function resetActionTypeInit(): void {
  initialized = false;
  lastAttempt = 0;
  setActionTypeEntries([]);
}
